export default __webpack_public_path__ + "static/media/startup.a0d7d574.svg";